import { Stack } from "@mui/material";
import { OutlinedSection } from "./outlinedSection";
import { PriceField } from "./priceField";
import { AdvancedField } from "./advancedField";

/**
 * Shared by the three rows so their inputs line up. Left to size itself, each
 * label column fits its own text, and "Update frequency" squeezed its input
 * narrower than the two above it.
 */
const LABEL_WIDTH = 140;

/** Narrowest an input stays readable at: a short value plus the ¥/kWh unit. */
const INPUT_MIN_WIDTH = 110;

/**
 * The frame's narrowest usable width, for the flex item wrapping it — that
 * item's `minWidth` is what makes the Advanced row break to a new line instead
 * of squeezing the inputs. Label and input, the 8px gap between them, and the
 * frame's 8px padding and 1px border on each side.
 */
export const LINEAR_CLOSER_FIELDS_MIN_WIDTH =
  LABEL_WIDTH + 8 + INPUT_MIN_WIDTH + 2 * (8 + 1);

/**
 * A LinearCloser's advanced settings — `initial_margin`, `final_margin` and
 * `upper_omt_update_frequency` — framed like the trade start and end beside
 * it in the Advanced section, with the labels beside the inputs as theirs are.
 * All optional; a blank one is sent as `null`.
 */
export const LinearCloserFields = () => (
  <OutlinedSection label="Linear specifics">
    <Stack spacing={0.5} direction="column">
      <PriceField
        name="initial_margin"
        label="Initial margin"
        placeholder="Initial"
        required={false}
        labelPlacement="start"
        labelWidth={LABEL_WIDTH}
      />
      <PriceField
        name="final_margin"
        label="Final margin"
        placeholder="Final"
        required={false}
        labelPlacement="start"
        labelWidth={LABEL_WIDTH}
      />
      <AdvancedField
        name="upper_omt_update_frequency"
        label="Update frequency"
        placeholder="Frequency"
        type="number"
        labelPlacement="start"
        labelWidth={LABEL_WIDTH}
        unit="s"
      />
    </Stack>
  </OutlinedSection>
);
